var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_10457)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F4EBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33301 9H13.6663",
    stroke: "#A20069",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.33301L13.6667 8.99967L9 13.6663",
    stroke: "#A20069",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#A20069"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_10457"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressArrow);
export default __webpack_public_path__ + "static/media/progress-arrow.8bee95f20a8cc2ca2f18975d01cd4c84.svg";
export { ForwardRef as ReactComponent };